/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFront from 'base/components/standalone/Front';

export const DynamicStandaloneFront = StandaloneFront;
export type DynamicStandaloneFrontProps = PropsFromComponent<typeof StandaloneFront>;

export const DynamicStandaloneFrontWith = (extras: DynamicStandaloneExtras): typeof StandaloneFront => {
    return function DynamicStandaloneFront(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Front');
        return <StandaloneFront {...mergeProps({ options: { theme } }, props)} />;
    }
}